(function () {
  function init() {
    var hero = document.querySelector('.hero__media');
    if (!hero) return;

    var heroSection = hero.closest('.hero') || hero;
    var ticking = false;

    function update() {
      ticking = false;
      var scrolledPast = window.scrollY || document.documentElement.scrollTop || 0;
      var progress = Math.min(1, Math.max(0, scrolledPast / 160));
      var eased = 1 - Math.pow(1 - progress, 2); // ease-out: fast start

      var translateY = eased * -120; // px, floats upward
      var scale = 1 + eased * 0.1; // slight expand as it drifts away
      var blur = eased * 8; // px

      hero.style.opacity = String(1 - eased);
      hero.style.transform = 'translateY(' + translateY + 'px) scale(' + scale + ')';
      hero.style.filter = 'blur(' + blur + 'px)';
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
